<template>

  <div>
    <header class="mobile">
      <div class="mobile-logo">
        <img src="@/assets/imgs/loginPage/logo.png">
      </div>
      <div class="mobile-menu-button" id="menu-button"  @click="changeVisible">
        <img src="@/assets/imgs/loginPage/mobmenu.png">
      </div>
      <div class="mobile-menu-button-close" id="close-button" style="display: none;">
        <img src="@/assets/imgs/loginPage/close.png">
      </div>
    </header>

    <header class="menu">
      <nav class="nav">
        <div class="logo">
          <img src="@/assets/imgs/loginPage/logo.png">
        </div>
        <ul class="menu-items">
          <li><a href="#about">О компании</a></li>
          <li><a href="#equipment">Состав оборудования</a></li>
          <li><a href="#advantages">Преимущества</a></li>
          <li><a href="#contacts">Контакты</a></li>
          <li class="separator"></li>
          <li><a href="#" class="login-button" @click="changeVisible">Войти</a></li>
        </ul>
      </nav>



      <div v-show="!isVisible" class="menu-text" id="default-text">
        <div class="menu-text-main">
          Программно аппаратный <span class="menu-text-color">комплекс</span> вибромониторинга
        </div>
        <div class="menu-text-additional">
          Регистрация 24/7 вибрации, температуры, времени работы вашего оборудования
        </div>
      </div>


      <div v-show="isVisible" class="menu-text hidden" id="login-text">
        <div class="menu-text-hidden">Вход</div>
        <div class="login-block">
          <div class="login-block-input">
            <div class="login">
              <label for="login-input">Введите Ваш логин</label>
              <Input type="text" placeholder="Введите логин" @keyup.enter="clickLogin" v-model="username" />
            </div>
            <div class="password">
              <label for="password-input">Введите Ваш пароль</label>
              <Input type="password" placeholder="Введите пароль" @keyup.enter="clickLogin" v-model="password" />
            </div>
          </div>

          <div class="block-button">
            <Button @click="clickLogin" :loading="loaderButton" text="Войти" />
            <div>
              <a href="#">Забыли пароль, нажмите здесь</a>
            </div>
          </div>
        </div>

      </div>


    </header>
    <img id="about" src="@/assets/imgs/loginPage/image.png" class="abstract">
  </div>

</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import Input from '@/components/Simple_elements/Input.vue'
import Button from '@/components/Simple_elements/Button.vue'

export default {
  components: {
    Input,
    Button,
  },

  data() {
    return {
      username: "",
      password: "",
      isVisible: false
    }
  },
  computed: {
    ...mapGetters('user', {
      userOptions: 'getUserOptions',
      loaderButton: 'getLoaderLoginButton'
    })
  },
  methods: {
    ...mapMutations('user', {
      setLogin: 'setLogin'
    }),
    ...mapActions('user', {
      postLogin: 'postLogin'
    }),
    clickLogin() {
      let options = {
        username: this.username,
        password: this.password
      }
      this.postLogin(options)
    },
    changeVisible() {
      this.isVisible = !this.isVisible
    }
  }

}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;

}

.page-root {

  height: auto;
  overflow-y: scroll;
  scroll-behavior: smooth;

  margin: 0;
  background-repeat: no-repeat;
  background-attachment: fixed;

  background-size: cover;

  font-family: 'Montserrat', sans-serif;

  font-weight: 400;

  font-size: 18px;

  line-height: 100%;

  letter-spacing: 0%;

  color: #FFFFFF;

  vertical-align: middle;

  scrollbar-width: none;

}


body::-webkit-scrollbar {
  display: none;
}


h1,
h2,
h3,
p {
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 18.01px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #FFFFFF;
  /* Белый цвет */
  vertical-align: middle;
}

#scrollToBottom1 {
  cursor: pointer;
  /* Указатель мыши изменится на руку при наведении */
}

#scrollToBottom2 {
  cursor: pointer;
  /* Указатель мыши изменится на руку при наведении */
}

#about {
  scroll-margin-top: -260px;
  /* Это добавит отступ в 100px сверху, чтобы изображение не скрывалось */
}

#equipment {
  scroll-margin-top: 260px;
  /* Это добавит отступ в 100px сверху, чтобы изображение не скрывалось */
}

#advantages {
  scroll-margin-top: 260px;
  /* Это добавит отступ в 100px сверху, чтобы изображение не скрывалось */
}

/* Общие стили для меню */
.menu {
  width: 1260px;
  height: 480px;
  margin: 90px auto 0 auto;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(150px);
  border-radius: 18px;
  box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.25);
  position: relative;
  z-index: 10;
  transition: opacity 0.3s ease;

  display: flex;
  flex-direction: column;
  /* Размещаем элементы вертикально */
  align-items: center;
  box-sizing: border-box;
  padding: 45px 45px 0 45px;
  /* Добавляем отступ сверху и по бокам */
}

/* Фиксированное меню */
.menu.fixed {

  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 1260px;
  height: 135px;
  z-index: 15;
  opacity: 0;
  transition: opacity 0.3s ease;

  display: flex;
  align-items: center;
  padding: 45px;
  pointer-events: none;
  /* Отступы сверху, слева и справа */
}

.hidden {
  display: none;
}

/* Когда фиксированное меню показывается */
.menu.fixed.show {
  opacity: 1;
  pointer-events: auto;
}

.hidden {
  display: none;
}

/* Анимация появления/скрытия */
.menu-text {
  transition: opacity 0.3s ease;
  display: block;
}

.menu-text-hidden {
  font-family: Montserrat;
  font-weight: 500;
  font-size: 32px;
  line-height: 100%;
  margin-bottom: 40px;
  display: block;
}

.login-block {
  width: 744px;
  height: auto;
  padding-left: 60px;
  position: relative;
  /* Для позиционирования псевдоэлементов относительно блока */
}

.login-block::before {
  content: "";
  position: absolute;
  left: 0;
  /* Полоска прижата к левой стороне блока */
  top: 0;
  width: 2px;
  height: 100%;
  /* Высота полоски на всю высоту блока */
  background-color: #ffffff;
}

.login-block::after {
  content: "";
  position: absolute;
  left: -4px;
  /* Позиционируем кружок на конце полоски */
  bottom: -6px;
  /* Позиционируем кружок ниже нижнего края полоски */
  width: 10px;
  height: 10px;
  background-color: #FFFFFF;
  border-radius: 50%;
}


.login-block-input {
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 744px;
}

.login,
.password {
  display: flex;
  flex-direction: column;
  width: 360px;
  font-family: Montserrat;
  font-weight: 400;
  font-size: 16px;
  color: white;
}

.login label,
.password label {
  margin-bottom: 8px;
}

.login input,
.password input {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 12px;
  color: white;
  font-size: 14px;
  outline: none;
}

.login input::placeholder,
.password input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}


.block-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 744px;
  gap: 12px;
  margin-top: 20px;
}

.block-button button {
  width: 744px;
  height: 53px;
  border-radius: 12px;
  border: none;
  font-family: Montserrat;
  font-weight: 500;
  font-size: 24px;
  background: #FFFFFF;
  color: #1A2857;
  cursor: pointer;
}

.block-button div {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
}

.block-button div a {
  color: #ffffff;
  text-decoration: underline;
}

/* Стили для nav */
.nav {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}


/* Логотип */
.logo img {
  width: 117px;
  height: 45px;
}

/* Стили для списка меню */
.menu-items {
  width: 835px;
  /* Растягиваем на всю ширину контейнера */
  height: 22px;
  display: flex;
  justify-content: space-between;
  /* Распределяем элементы по краям */
  align-items: center;
  padding: 0;
  /* Убираем padding */
  margin: 0;
  /* Убираем margin */
}

.menu-items li {
  list-style-type: none;
  margin: 0;
  /* Убираем маргины у li */
  padding: 0;
  /* Убираем padding у li */
}

.menu-items a {
  text-decoration: none;
  color: #ffffff;
  font-size: 1rem;
  /* 16px эквивалентно 1rem */
}

/* Стили для разделителя */
.separator {
  border-left: 1px solid #ffffff;
  height: 30px;
  margin: 0 15px;
}

.mobile {
  display: none;
}

/* Стили для .abstract */
.abstract {
  width: 900px;
  position: absolute;
  /* Позиционируем картинку относительно родительского контейнера */
  top: 50px;
  /* Отступ сверху относительно родителя */
  right: 0px;
  /* Отступ слева относительно родителя */
  z-index: 100;
  pointer-events: none;
  /* Устанавливаем порядок слоя */
}

/* Стили для .menu-text */
.menu-text {
  width: 100%;
  height: 254px;
  margin-top: 90px;
  margin-bottom: 45px;
  align-self: flex-start;
  /* Прижимает к левому краю */
  position: relative;
  /* Для работы абсолютного позиционирования картинки */
}


.menu-text-main {
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 48.02px;
  line-height: 1.2;
  color: #FFFFFF;
  width: 637px;
  height: 171px;

}

.menu-text-color {
  color: #1A2857;
  /* Цвет для части текста */

}

.menu-text-additional {
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 1.2;
  margin-top: 14px;
  width: 637px;
  height: 58px;

}

.menu-text img {
  width: 60px;
  height: 60px;
  position: absolute;
  /* Позиционируем картинку относительно родительского контейнера */
  bottom: 0;
  /* Отступ снизу */
  right: 0;
  /* Отступ справа */
}

@media screen and (max-width: 1440px) {

  .menu {
    margin: 0px;
    margin-left: 45px;
    margin-right: 45px;
    margin-top: 45px;

    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
    padding: 45px 45px 0 45px;
  }

  .menu.fixed {
    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    margin: 0 auto;
    box-sizing: border-box;
    margin-top: 20px;
  }
}



@media screen and (min-width: 768px) and (max-width: 1024px) {

  .menu {
    margin: 0px;
    margin-left: 45px;
    margin-right: 45px;
    margin-top: 45px;

    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
    padding: 45px 45px 0 45px;
  }

  .menu-text {
    width: 100%;
  }

  .menu-items {
    width: 86%;
  }

  .menu-items a {
    font-size: 0.8rem;
  }

  /* Стили для .abstract */
  .abstract {
    width: 500px;
  }

  .menu.fixed {
    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    margin: 0 auto;
    box-sizing: border-box;
    margin-top: 20px;
  }

  .logo img {
    width: 80px;
    height: auto;
  }


  #login-text.menu-text {
    width: 100%;
    /* 100% ширины родительского блока */
    height: auto;
    padding: 20px;
    /* Внутренние отступы для блока */
    box-sizing: border-box;
    /* Учитывает padding в ширине/высоте */
    margin: 0;
    /* Убирает все внешние отступы */
  }

  #login-text.menu-text img {
    display: none;
  }

  #login-text .login-block {
    width: 100%;
    /* 100% ширины родительского блока */
    padding: 20px;
    /* Внутренние отступы для блока */
    box-sizing: border-box;
    /* Учитывает padding в ширине/высоте */
    margin: 0;
    /* Убирает все внешние отступы */

  }

  .menu-text-hidden {
    width: 300px;
    margin-bottom: 10px;
  }

  .block-button {
    width: 100%;
  }

  .block-button button {
    width: 100%;
    height: 42px;
    font-size: 18px;
  }

  /* Обновляем login-block-input, чтобы элементы выстраивались вертикально */
  .login-block-input {
    display: flex;
    flex-direction: column;
    /* Расставляем элементы по вертикали */
    gap: 16px;
    /* Добавляем промежутки между элементами */
    width: 100%;
    /* Растягиваем на всю доступную ширину */
  }

  /* Стили для каждого из полей ввода (login и password) */
  .login,
  .password {
    display: flex;
    flex-direction: column;
    /* Выстраиваем элементы внутри по вертикали */
    width: 100%;
  }

  .login label,
  .password label {
    margin-bottom: 8px;
  }

  .login input,
  .password input {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    padding: 12px;
    color: white;
    font-size: 14px;
    outline: none;
    width: 100%;
    /* Растягиваем поля ввода на всю ширину контейнера */
    box-sizing: border-box;
  }

}

@media screen and (min-width: 425px) and (max-width: 768px) {
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html,
  body {
    overflow: hidden;
    scroll-behavior: smooth;
  }

  html {
    overflow-y: scroll;
    scrollbar-width: none;
  }

  .menu.fixed {
    display: none;
  }

  .mobile {
    display: flex;
    width: 100%;
    height: 66px;
    justify-content: space-between;
    padding: 22px;
  }

  .mobile-logo {
    display: flex;
    width: 58px;
    height: 22px;
  }

  .mobile-menu-button {
    width: 24px;
    height: 16px;
    display: flex;
  }

  .mobile-menu-button-close {
    width: 16px;
    height: 16px;
  }

  .logo {
    display: none;
  }

  .menu {
    margin: 0px;
    margin-left: 20px;
    margin-right: 20px;
    padding: 0px;
    width: calc(100% - 40px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
  }

  #default-text.menu-text * {
    box-sizing: inherit;
  }


  #default-text.menu-text {
    width: 100%;
    /* 100% ширины родительского блока */
    padding: 20px;
    /* Внутренние отступы для блока */
    box-sizing: border-box;
    /* Учитывает padding в ширине/высоте */
    margin: 0;
    /* Убирает все внешние отступы */
  }

  #default-text .menu-text-main {
    font-family: 'Montserrat', sans-serif;
    font-weight: 800;
    font-size: 24px;
    line-height: 1.2;
    letter-spacing: 0%;
    margin-top: 0;
    margin-bottom: 16px;
    /* Отступ снизу от текста */
    width: 100%;
    /* Текст будет не больше ширины родительского блока */
    overflow-wrap: break-word;
    /* Переносит длинные слова, чтобы текст не выходил за пределы */
    word-wrap: break-word;
    /* Для старых браузеров */
    height: auto;
  }

  #default-text .menu-text-additional {
    font-family: Montserrat;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    margin-bottom: 16px;
    /* Отступ снизу от дополнительного текста */
    width: 100%;
    /* Текст будет не больше ширины родительского блока */
    overflow-wrap: break-word;
    /* Переносит длинные слова, чтобы текст не выходил за пределы */
    word-wrap: break-word;
    /* Для старых браузеров */
    height: auto;
  }


  #default-text .menu-button {
    display: block;
    /* Убираем inline-стили */
    width: 36px;
    height: 36px;
    margin-top: 16px;
    /* Отступ сверху */
    padding: 20px;
  }

  #default-text img {
    display: block;
    /* Убираем inline-стили */
    width: 36px;
    height: 36px;
    margin-top: 16px;
    /* Отступ сверху */
  }


  .menu-items {
    display: none;
  }

  .abstract {
    display: none;
  }

  #login-text.menu-text * {
    box-sizing: inherit;
  }


  #login-text.menu-text {
    width: 100%;
    /* 100% ширины родительского блока */
    height: auto;
    padding: 20px;
    /* Внутренние отступы для блока */
    box-sizing: border-box;
    /* Учитывает padding в ширине/высоте */
    margin: 0;
    /* Убирает все внешние отступы */
  }

  #login-text.menu-text img {
    display: none;
  }

  #login-text .login-block {
    width: 100%;
    /* 100% ширины родительского блока */
    padding: 20px;
    /* Внутренние отступы для блока */
    box-sizing: border-box;
    /* Учитывает padding в ширине/высоте */
    margin: 0;
    /* Убирает все внешние отступы */

  }

  .menu-text-hidden {
    width: 300px;
    margin-bottom: 10px;
  }

  .block-button {
    width: 100%;
  }

  .block-button button {
    width: 100%;
    height: 42px;
    font-size: 18px;
  }

  /* Обновляем login-block-input, чтобы элементы выстраивались вертикально */
  .login-block-input {
    display: flex;
    flex-direction: column;
    /* Расставляем элементы по вертикали */
    gap: 16px;
    /* Добавляем промежутки между элементами */
    width: 100%;
    /* Растягиваем на всю доступную ширину */
  }

  /* Стили для каждого из полей ввода (login и password) */
  .login,
  .password {
    display: flex;
    flex-direction: column;
    /* Выстраиваем элементы внутри по вертикали */
    width: 100%;
  }

  .login label,
  .password label {
    margin-bottom: 8px;
  }

  .login input,
  .password input {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    padding: 12px;
    color: white;
    font-size: 14px;
    outline: none;
    width: 100%;
    /* Растягиваем поля ввода на всю ширину контейнера */
    box-sizing: border-box;
  }
}


@media (max-width: 425px) {
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html,
  body {
    overflow: hidden;
    scroll-behavior: smooth;
  }

  html {
    overflow-y: scroll;
    scrollbar-width: none;
  }

  br {
    display: none;
  }

  body::-webkit-scrollbar {
    display: none;
  }

  .menu.fixed {
    display: none;
  }

  .mobile {
    display: flex;
    width: 100%;
    height: 66px;
    justify-content: space-between;
    padding: 22px;
  }

  .mobile-logo {
    display: flex;
    width: 58px;
    height: 22px;
  }

  .mobile-menu-button {
    width: 24px;
    height: 16px;
    display: flex;
  }

  .mobile-menu-button-close {
    width: 16px;
    height: 16px;
  }

  .logo {
    display: none;
  }

  .menu {
    margin: 0px;
    margin-left: 20px;
    margin-right: 20px;
    padding: 0px;
    width: calc(100% - 40px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
  }

  #default-text.menu-text * {
    box-sizing: inherit;
  }


  #default-text.menu-text {
    width: 100%;
    /* 100% ширины родительского блока */
    padding: 20px;
    /* Внутренние отступы для блока */
    box-sizing: border-box;
    /* Учитывает padding в ширине/высоте */
    margin: 0;
    /* Убирает все внешние отступы */
  }

  #default-text .menu-text-main {
    font-family: 'Montserrat', sans-serif;
    font-weight: 800;
    font-size: 24px;
    line-height: 1.2;
    letter-spacing: 0%;
    margin-top: 0;
    margin-bottom: 16px;
    /* Отступ снизу от текста */
    width: 100%;
    /* Текст будет не больше ширины родительского блока */
    overflow-wrap: break-word;
    /* Переносит длинные слова, чтобы текст не выходил за пределы */
    word-wrap: break-word;
    /* Для старых браузеров */
    height: auto;
  }

  #default-text .menu-text-additional {
    font-family: Montserrat;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    margin-bottom: 16px;
    /* Отступ снизу от дополнительного текста */
    width: 100%;
    /* Текст будет не больше ширины родительского блока */
    overflow-wrap: break-word;
    /* Переносит длинные слова, чтобы текст не выходил за пределы */
    word-wrap: break-word;
    /* Для старых браузеров */
    height: auto;
  }


  #default-text .menu-button {
    display: block;
    /* Убираем inline-стили */
    width: 36px;
    height: 36px;
    margin-top: 16px;
    /* Отступ сверху */
    padding: 20px;
  }

  #default-text img {
    display: block;
    /* Убираем inline-стили */
    width: 36px;
    height: 36px;
    margin-top: 16px;
    /* Отступ сверху */
  }


  .menu-items {
    display: none;
  }

  .abstract {
    display: none;
  }

  #login-text.menu-text * {
    box-sizing: inherit;
  }


  #login-text.menu-text {
    width: 100%;
    /* 100% ширины родительского блока */
    height: auto;
    padding: 20px;
    /* Внутренние отступы для блока */
    box-sizing: border-box;
    /* Учитывает padding в ширине/высоте */
    margin: 0;
    /* Убирает все внешние отступы */
  }

  #login-text.menu-text img {
    display: none;
  }

  #login-text .login-block {
    width: 100%;
    /* 100% ширины родительского блока */
    padding: 20px;
    /* Внутренние отступы для блока */
    box-sizing: border-box;
    /* Учитывает padding в ширине/высоте */
    margin: 0;
    /* Убирает все внешние отступы */

  }

  .menu-text-hidden {
    width: 300px;
    margin-bottom: 10px;
  }

  .block-button {
    width: 100%;
  }

  .block-button button {
    width: 100%;
    height: 42px;
    font-size: 18px;
  }

  /* Обновляем login-block-input, чтобы элементы выстраивались вертикально */
  .login-block-input {
    display: flex;
    flex-direction: column;
    /* Расставляем элементы по вертикали */
    gap: 16px;
    /* Добавляем промежутки между элементами */
    width: 100%;
    /* Растягиваем на всю доступную ширину */
  }

  /* Стили для каждого из полей ввода (login и password) */
  .login,
  .password {
    display: flex;
    flex-direction: column;
    /* Выстраиваем элементы внутри по вертикали */
    width: 100%;
  }

  .login label,
  .password label {
    margin-bottom: 8px;
  }

  .login input,
  .password input {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    padding: 12px;
    color: white;
    font-size: 14px;
    outline: none;
    width: 100%;
    /* Растягиваем поля ввода на всю ширину контейнера */
    box-sizing: border-box;
  }
}

@media (max-width: 320px) {
  .login-block {
    max-width: 260px;
  }

  .block-button {
    max-width: 220px;
  }

  .block-button button {
    max-width: 220px;
  }

  .menu-text-hidden {
    font-size: 24px;
  }
}







.about {
  display: flex;
  margin: 60px auto;
  width: 1260px;
  justify-content: space-between;
  /* Распределение блоков по ширине */
  flex-wrap: wrap;
  /* Разрешаем перенос элементов */
}

/* Стили для каждого блока */
.about-block {
  display: flex;
  flex-direction: column;
  /* Вертикальное расположение элементов */
  align-items: center;
  /* Центрируем элементы по горизонтали */
  gap: 18px;
  /* Расстояние между картинкой, линией и текстом */
  width: 390px;
  height: auto;
  /* Высота будет зависеть от содержимого */
}

.about-block img {
  width: 60px;
  height: 60px;
}

.line {
  width: 100%;
  height: 2px;
  background-color: #FFFFFF;
  /* Белая линия */
  position: relative;
  /* Для позиционирования круга */
}

.circle {
  width: 10px;
  height: 10px;
  background-color: #FFFFFF;
  /* Белый круг */
  border-radius: 50%;
  /* Делает круг */
  position: absolute;
  right: 0;
  /* Круг будет справа на линии */
  top: 50%;
  /* По вертикали по центру */
  transform: translateY(-50%);
  /* Выравнивание по центру линии */
}

.about-text {
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 24.01px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
}

.about-text span {
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 24.01px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
}

@media screen and (max-width: 1440px) {

  .about {
    margin: 0px;
    margin-left: 45px;
    margin-right: 45px;
    margin-top: 45px;

    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
  }

  .about-block {
    width: 30%;
  }
}


/* Медиазапросы для адаптивности */
@media (max-width: 1024px) {
  .about {
    margin: 0px;
    margin-left: 45px;
    margin-right: 45px;
    margin-top: 45px;

    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
  }

  .about-block {
    width: 30%;
  }

  .about-text {
    font-size: 18px;
    /* Уменьшаем размер шрифта для мобильных */
  }

  .about-text span {
    font-size: 18px;
    /* Уменьшаем размер шрифта для мобильных */
  }

}

@media (max-width: 768px) {
  .about {
    flex-direction: column;
    margin: 0px;
    margin-left: 45px;
    margin-right: 45px;
    margin-top: 45px;

    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
  }

  .about-block {
    width: 100%;
    margin-bottom: 30px;
  }

  .about-text {
    font-size: 18px;
    /* Уменьшаем размер шрифта для мобильных */
  }

  .about-text span {
    font-size: 18px;
    /* Уменьшаем размер шрифта для мобильных */
  }
}

@media (max-width: 480px) {
  .about {
    padding: 0 20px;
    /* Добавляем отступы для маленьких экранов */
  }

  .about-text {
    font-size: 16px;
    /* Еще уменьшаем шрифт */
  }

  .about-text span {
    font-size: 16px;
    /* Еще уменьшаем шрифт */
  }

  .about-block img {
    width: 50px;
    /* Уменьшаем размер изображений на мобильных */
    height: 50px;
    /* Уменьшаем размер изображений на мобильных */
  }
}




.structure {
  width: 1260px;
  margin: 34px auto 0 auto;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.structure-text {
  width: 100%;
  height: 49px;
  margin-bottom: 30px;
  font-family: Montserrat;
  font-weight: 800;
  font-size: 40px;
}

.structure-content {
  display: flex;
  justify-content: space-between;
  gap: 30px;
}

.structure-block {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  /* Чтобы скрыть дополнительный контент, когда он свернут */
  transition: height 0.3s ease-in-out;
}

.structure-block img {
  width: 146px;
  height: 180px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

.structure-block-text {
  display: flex;
  align-items: center;
  font-family: Montserrat;
  font-weight: 400;
  font-size: 24px;
  white-space: nowrap;
  margin-top: 18px;
  margin-bottom: 18px;
}

.structure-block-text img {
  width: 27px;
  height: 27px;
  margin-left: 5px;
  transition: transform 0.3s ease;
  /* Добавляем анимацию поворота */
}

/* Дополнительный контент (скрыт по умолчанию) */
.structure-content-extra {
  width: 100%;
  display: none;
  padding-top: 24px;
}

.structure-content-extra-text {
  margin-top: 24px;
  margin-bottom: 12px;
}

@media screen and (max-width: 1440px) {
  .structure {
    margin: 0px;
    margin-left: 45px;
    margin-right: 45px;
    margin-top: 45px;

    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 1440px) {
  .structure {
    margin: 0px;
    margin-left: 45px;
    margin-right: 45px;
    margin-top: 45px;

    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
  }
}

@media (max-width: 1024px) {
  .structure {
    margin: 0px;
    margin-left: 45px;
    margin-right: 45px;
    margin-top: 45px;

    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
  }
}


@media (max-width: 768px) {
  .structure {
    width: 100%;
    /* Блоки будут занимать всю ширину экрана */
    margin: 34px auto 0 auto;
    flex-direction: column;
    /* Блоки будут располагаться вертикально на маленьких экранах */
    align-items: center;
    /* Центрируем блоки по горизонтали */
  }

  .structure-text {
    font-family: Montserrat;
    font-weight: 800;
    font-size: 24px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    width: 192px;
    height: 58px;

  }

  .structure-content {
    flex-direction: column;
    /* Блоки идут вертикально */
    gap: 20px;
    /* Меньше отступов между блоками */
    width: 100%;
    align-items: center;
    /* Центрируем блоки по горизонтали */
  }

  .structure-block {
    width: 80%;
    /* Блоки занимают 80% ширины */
    max-width: 350px;
    /* Ограничиваем максимальную ширину блоков */
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .structure-block img {
    width: 195px;
    height: 240px;

  }

  .structure-block-text {
    font-family: Montserrat;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;


  }

  .structure-block-text img {
    width: 20px;
    height: 20px;
  }

  .structure-content-extra {

    padding-top: 0px;
  }

  .structure-content-extra-text {
    font-family: Montserrat;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;

  }
}




.advantages {
  margin: 60px auto 0 auto;
  width: 1260px;
  /* Устанавливаем ширину 100% для адаптивности */
  height: auto;
  box-sizing: border-box;
  /* Чтобы padding не выходил за пределы контейнера */
}

.advantages-text {
  width: 340px;
  height: 49px;
  font-size: 40px;
  font-weight: bold;
}

.advantages-content {
  position: relative;
  width: 100%;
  /* Ширина будет 100% от родителя */
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-left: 45px;
  box-sizing: border-box;
  word-wrap: break-word;
  /* Перенос слов внутри контента */
}

.advantages-content::before {
  content: "";
  position: absolute;
  left: 10px;
  top: 0;
  width: 2px;
  height: 100%;
  background-color: white;
}

.advantages-content::after {
  content: "";
  position: absolute;
  left: 6px;
  bottom: 0;
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 50%;
}

.advantages-block {
  width: 100%;
  /* Блоки будут адаптироваться под ширину экрана */

  height: auto;
  border-radius: 18px;
  border: 0.75px solid rgba(255, 255, 255, 0.3);
  padding: 18px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(150px);
  box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.25);
  text-align: left;
  line-height: 30px;
  box-sizing: border-box;
  position: relative;
  word-wrap: break-word;
  /* Перенос длинных слов в блоках */
}

.scrollUp {
  margin-right: 10px;
  width: 60px;
  height: 60px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  border-radius: 50%;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 999;
}

.scrollUp img {
  width: 30px;
  height: 30px;
  transition: transform 0.3s ease;
}

@media screen and (max-width: 1440px) {
  .advantages {
    margin: 0px;
    margin-left: 45px;
    margin-right: 45px;
    margin-top: 45px;

    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
  }

}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .advantages {
    margin: 0px;
    margin-left: 45px;
    margin-right: 45px;
    margin-top: 45px;

    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
  }

  .advantages-content {
    max-width: 1000px;
    margin: 0 auto;
  }
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .advantages-content {
    padding-left: 0px;
  }

  .advantages-text {
    font-size: 24px;
  }

  .advantages-block {
    font-size: 14px;
    padding: 12px;
    font-family: Montserrat;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;

  }

  .scrollUp {
    display: none;
  }

  .scrollUp img {
    width: 20px;
    height: 20px;
  }

  /* Скрываем боковую линию на мобильных устройствах */
  .advantages-content::before {
    display: none;
  }

  /* Скрываем боковую линию на мобильных устройствах */
  .advantages-content::after {
    display: none;
  }
}




.contacts {
  width: 1260px;
  margin: 60px auto;
  text-align: left;
  height: auto;
  padding-left: 5px;
}

.contacts-text {
  font-family: Montserrat;
  font-weight: 800;
  font-size: 40.52px;
  line-height: 100%;
  height: 49px;
  margin-bottom: 30px;
  /* Отступ между заголовком и контактами */
}

.contacts-content {
  position: relative;
  /* Для добавления линии и кружка */
  font-family: Montserrat;
  font-weight: 500;
  font-size: 24px;
  line-height: 100%;
  display: flex;
  gap: 30px;
  /* Отступ между email и телефоном */
  align-items: center;
  /* Выравнивание по вертикали */
  max-width: 100%;
  /* Чтобы не выходило за границы */
  padding-left: 45px;
  /* Отступ между текстом и линией */
}

/* Линия слева */
.contacts-content::before {
  content: "";
  position: absolute;
  left: 0;
  /* Ставим в край */
  top: 0;
  width: 2px;
  height: 100%;
  background-color: white;
}

/* Кружочек внизу линии */
.contacts-content::after {
  content: "";
  position: absolute;
  left: -4px;
  bottom: -6px;
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 50%;
}

@media (max-width: 1440px) {
  .contacts {
    margin: 0px;
    margin-left: 45px;
    margin-right: 45px;
    margin-top: 45px;

    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
  }
}

@media (max-width: 1024px) {
  .contacts {
    margin: 0px;
    margin-left: 45px;
    margin-right: 45px;
    margin-top: 45px;

    width: calc(100% - 90px);
    /* 100% ширины экрана минус отступы по 20px с каждой стороны */
    height: auto;
    box-sizing: border-box;
  }
}

/* Адаптив для экранов < 768px */
@media (max-width: 768px) {
  .contacts-content {
    font-size: 18px;
    gap: 18px;
    flex-direction: column;
    align-items: flex-start;
    padding-left: 24px;
    /* Оставляем отступ */
  }

  .contacts-text {
    font-family: Montserrat;
    font-weight: 800;
    font-size: 24px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;

    height: 29px;
    margin-bottom: 16px;


  }

  .contacts-content::after {
    width: 6px;
    height: 6px;
    left: -3px;
  }

  .contacts-content::before {
    width: 1px;
  }
}

/* Адаптив для экранов < 480px */
@media (max-width: 480px) {
  .contacts-content {
    font-size: 16px;
    gap: 12px;
  }

}

/* Адаптив для экранов < 425px */
@media (max-width: 425px) {
  .contacts-content {
    font-size: 16px;
    gap: 12px;
  }

}


footer {
  width: 100%;
  height: 50px;
  margin-bottom: 45px;
  margin-top: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  text-align: center;
  color: #FFFFFF;
  flex-wrap: wrap;
  /* Чтобы текст не выходил за границы на маленьких экранах */
}

footer span {
  margin: 0 15px;
  /* Отступы между текстами */
}

/* Адаптив для экранов < 768px */
@media (max-width: 768px) {
  footer {
    font-size: 10px;
  }

  footer span {
    margin: 0 10px;
    /* Уменьшаем отступы */
  }
}

/* Адаптив для экранов < 480px */
@media (max-width: 480px) {
  footer {
    font-size: 8px;
  }

  footer span {
    margin: 0 5px;
    /* Еще чуть уменьшаем отступы */
  }
}
</style>
